
import "/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/components/NoticeTransitIcon/index.less?modules";
export default {"icon": `icon-oIzTlkDX`,"badge": `badge-s1jC3bY2`,"tabs": `tabs-7L2vZcHG`,"tabLabel": `tabLabel-4zgR-JXv`,"opened": `opened-YewrE1jm`,"popover": `popover-dxMqY5Xz`,"noticeButton": `noticeButton-FNU1LDZx`}
